import { InternalScheduleHeaderPendingProps } from './types';
import { HEADER_GRID_CLASSNAME } from '../constants';

export const InternalScheduleHeaderPending = ({
  dateControl,
}: InternalScheduleHeaderPendingProps) => (
  <div aria-busy className={HEADER_GRID_CLASSNAME}>
    {dateControl}
    <div className="h-8 w-full max-w-[335px] animate-pulse rounded bg-neutral-100" />
    <div className="flex justify-center">
      <div className="my-0.5 h-[18px] w-36 animate-pulse rounded bg-neutral-100" />
    </div>
    <div className="min-h-6" />
  </div>
);
